import { environment } from './../../environments/environment';
import { ResourceModel } from './../product-category/models/resource.model';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { Http, Response } from '@angular/http';
import { FormBuilder, FormGroup, Validator, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ProductCategoryService } from '../product-category/services/product-category.service';
import notify from 'devextreme/ui/notify';
import { SearchResultModel } from './models/search-result.model';



@Component({
  selector: 'app-search-results',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit {
  searchresults: SearchResultModel[] = [];
  searchkey: string;
  roles: string;
  isLoading = true;

  constructor(private service: ProductCategoryService, private hostElement: ElementRef, private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
    const searchkeyAtt = this.hostElement.nativeElement.getAttributeNode('key');
    this.searchkey = searchkeyAtt && searchkeyAtt.value ? searchkeyAtt.value : '';

    const rolesAtt = this.hostElement.nativeElement.getAttributeNode('roleperm');
    this.roles = rolesAtt && rolesAtt.value ? rolesAtt.value : '';

    this.getSearchResults(this.searchkey, this.roles);
  }



  getSearchResults(key: string, roles: string) {
    this.isLoading = true;

    this.service.getContentSearchResults(key, roles)
      .subscribe(
        res => {
          let result: SearchResultModel[] = [];
          let searchresultArray: any[];
          searchresultArray = res as any[];
          result = searchresultArray ? searchresultArray.map(item => new SearchResultModel(item)) : [];
          result.forEach(r => {
            const rawLines = r.line ? r.line.split(',') : [];
            const lines = rawLines.map(l => l.trim());

            if (rawLines.length == 0) {
              if (r.objecttypefound === 'producttype') {
                r.url = `${environment.umbracoUrl}${r.line === 'Commercial' ? 'commercial' : 'residential-light-commercial'}/product-type/?productTypeId=${r.producttypeid}&iscommercial=${r.line === 'Commercial' ? 'true' : 'false'}`;
              }
              if (r.objecttypefound === 'model') {
                r.url = `${environment.umbracoUrl}${r.line === 'Commercial' ? 'commercial' : 'residential-light-commercial'}/product-type/model-details/?productTypeId=${r.producttypeid}&modelId=${r.modelid}&modelNumber=${r.modelnumber}&iscommercial=${r.line === 'Commercial' ? 'true' : 'false'}`;
              }

              this.searchresults.push(r);
            }

            lines.forEach(line => {
              const isCommercial = line === 'Commercial';
              const urlPath =isCommercial ? 'commercial' : 'residential-light-commercial';
              const basePath = isCommercial ? 'Commercial' : 'Residential and Light Commercial';


              let url = '';

              if (r.objecttypefound.toLowerCase() == 'producttype') {
                url = `${environment.umbracoUrl}${urlPath}/product-type/?productTypeId=${r.producttypeid}&iscommercial=${isCommercial}`;
              }

              if (r.objecttypefound.toLowerCase() == 'model') {
                url = `${environment.umbracoUrl}${urlPath}/product-type/model-details/?productTypeId=${r.producttypeid}&modelId=${r.modelid}&modelNumber=${r.modelnumber}&iscommercial=${isCommercial}`;
              }
              const modifiedTitle =`${r.title} - ${basePath}` ;
              const clonedResult = { ...r, url, title: modifiedTitle };
              this.searchresults.push(clonedResult);
            });
          });
          history.pushState(null, '', location.href.split('?')[0]);
          this.isLoading = false;
        },
        err => {
          this.isLoading = false;
          if (key === '') {
            notify('Please enter a search term', 'warning', 3000);
          } else {
            notify('There was an error getting search results. Please try again. test', 'error', 3000)
          }
        }

      );

    // TODO: This is for testing purposes only
    // this.samplesearchresults();

  }


  samplesearchresults() {

    for (let i = 1; i < 50; i++) {
      const searchresult = new SearchResultModel();
      searchresult.additionalinfo = 'additionalinfo blah blah blah ' + i.toString();
      searchresult.description = 'description blah blah blah ' + i.toString();
      searchresult.objecttypefound = 'producttype';
      searchresult.title = 'product type ' + i.toString();
      searchresult.url = environment.umbracoUrl + 'residential-light-commercial' + '/product-type/?productTypeId=12345';
      this.searchresults.push(searchresult);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/search-results/search-result.component.ts